import React, { useState, useEffect, useRef, Fragment } from "react";
import { connect } from "react-redux";
import {
  AddIcon,
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  CopyIcon,
  CSVIcon,
  FilterIcon,
  ResetIcon,
  WorksheetIcon,
  EditIcon,
} from "../../../assets/icons";
import Pagination from "../../shared/common/pagination";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { Menu, Transition } from "@headlessui/react";
import Select from "react-select";
import ExportToCSV from "../../shared/common/exportToCsv";
import {
  getSupersheet,
  getGradeAll,
  getSubjectAll,
  getSubjectAllByContent,
  previewSuperSheet,
  downloadaAnswerKeySupersheet,
} from "../../../api/supersheet.service";
import { getContentArea } from "../../../api/contentArea.service";
import ShareSupersheet from "../../shared/common/shareSupersheet";
import Loader from "../../shared/loader/loader";
import { ISupersheetFilter } from "../../../model/interface/supersheet";
import { DotsVerticalIcon } from "@heroicons/react/outline";
import { toast } from "react-toastify";
import constant from "../../../utils/constant";
import { Link, useNavigate } from "react-router";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Supersheet: React.FC = (props: any) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const initialState = {
    name: "",
    contentAreaId: 0,
    contentAreaName: "",
    gradeId: 0,
    gradeName: "",
    stateId: 0,
    stateName: "",
    gradeLevelId: 0,
    gradeLevelName: "",
    isActive: true,
    isApproved: true,
    notes: "",
    scoringAlgorithm: "",
    subjectId: 0,
    subjectName: "",
    supersheetId: "",
  };
  const [filterInput, setFilterInput] = useState<any>(initialState);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [newGrade, setNewGrade] = useState<any>([]);
  const [newSubject, setNewSubject] = useState<any>([]);
  const [newContent, setNewContent] = useState<any>([]);
  const [newSupersheet, setNewSupersheet] = useState<any>([]);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const navigate = useNavigate();
  //Selected
  const [selectedSupersheetId, setSelectedSupersheetId] = useState<number>();
  const [selectedTitle, setSelectedTitle] = useState<string>();
  const [selectedSubjectId, setSelectedSubjectId] = useState<number>();
  const [selectedSubjectName, setSelectedSubjectName] = useState<string>();
  const [selectedShareSubjectIds, setSelectedShareSubjectIds] =
    useState<string>();

  //Loading
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isAlert, setIsAlert] = useState<boolean | null>(null);
  const childRef: any = useRef(undefined);

  //Paging
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortCol, setSortCol] = useState<string>("supersheetId");
  const [sortByDesc, setSortByDesc] = useState<boolean>(false);
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);

  //Inline dropdown
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];

  const handleRedirect = (id?: number | string) => {
    navigate(
      id
        ? constant.EDITSUPERSHEET.replace(":id", id.toString())
        : constant.ADDSUPERSHEET,
      { state: { idToEdit: id } }
    );
  };

  //API Calls Section
  const getSupersheetData = async () => {
    filterSupersheets();
  };
  const getGradeData = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setNewGrade(newGradeData);
  };
  const getSubjectData = async () => {
    const response = getSubjectAll(999, 1);
    const data = (await response).data;
    let newSubjectData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.subjectId - secondItem.subjectId
      );
      newSubjectData = data.data.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.name}`,
        };
      });
    }
    setNewSubject(newSubjectData);
  };

  const bindContentAreaByGrade = async (userId, gradeId, contentAreaId) => {
    const response = getSubjectAllByContent(userId, gradeId, contentAreaId);
    const data = (await response).data.supersheetContentAreaGroup;
    let newContentAreaData = [];
    if (data.length > 0) {
      data.sort(
        (firstItem, secondItem) =>
          firstItem.contentAreaId - secondItem.contentAreaId
      );
      newContentAreaData = data.map((eachContentAreaData) => {
        return {
          value: eachContentAreaData.contentAreaId || 0,
          label: `${eachContentAreaData.contentAreaName}`,
        };
      });
    }
    setNewContent(newContentAreaData);
  };

  const bindSubjectByContent = async (userId, gradeId, contentAreaId) => {
    const response = getSubjectAllByContent(userId, gradeId, contentAreaId);
    const data = (await response).data.supersheetSubjectGroup;
    let newSubjectData = [];
    if (data.length > 0) {
      data.sort(
        (firstItem, secondItem) => firstItem.subjectId - secondItem.subjectId
      );
      newSubjectData = data.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.subjectName}`,
        };
      });
    }
    setNewSubject(newSubjectData);
  };
  const getContent = async () => {
    const response = getContentArea(999, 1);
    const data = (await response).data;
    setNewContent(data.data);
    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setNewContent(newContentData);
  };

  function filterSupersheets(resetObj?, onFilter?, onDelete?) {
    setLoading(true);
    if (onFilter) setIsFilter(true);

    const supersheetData: ISupersheetFilter = {
      name: filterInput.name || "",
      subjectId: filterInput.subjectId || 0,
      contentAreaId: filterInput.contentAreaId || 0,
      gradeId: filterInput.gradeId || 0,
      gradeLevel: filterInput.gradeLevelId || "",
      orderbyColumn: sortCol,
      sortDir: sortByDesc ? "DESC" : "ASC",
      pageSize: onDelete ? pageSize : onFilter ? defaultPageSize : pageSize,
      pageNumber: onDelete
        ? pageNumber
        : onFilter
        ? defaultPageNumber
        : pageNumber,
      isActive: filterInput.isActive,
      isApproved: filterInput.isApproved,
      supersheetId: filterInput.supersheetId || 0,
      subjectTypeId: filterInput.subjectTypeId,
      isAlert,
    };

    getSupersheet(resetObj ? resetObj : supersheetData).then(
      (response: any) => {
        setLoading(false);
        setNewSupersheet(response.data.data);
        setTotalPages(
          Math.ceil(
            response.data.totalRecords / (resetObj ? defaultPageSize : pageSize)
          )
        );
        setTotalRecords(response.data.totalRecords);
        if (onFilter) {
          if (!onDelete) {
            paginationRef?.current?.onReset();
            pageSizeRef?.current?.onReset();
          }
          setIsFilter(false);
        }
      }
    );
  }

  //Input Handlers
  const filterHandler = (e) => {
    e.preventDefault();
    filterSupersheets(false, true);
  };
  const filterInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setFilterInput({
      ...filterInput,
      [name]: value,
    });
    if (e.target.value === "") {
      filterSupersheets();
    }
  };
  const resetClickHandler = () => {
    setResetDropdownFlag(!resetDropdownFlag);
    setFilterInput({
      ...initialState,
    });
    filterSupersheets({
      subjectId: 0,
      gradeId: 0,
      contentAreaId: 0,
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      orderbyColumn: "supersheetId",
      sortDir: "asc",
      isActive: true,
      isApproved: true,
      supersheetId: 0,
      isAlert: null,
    });
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };
  const updateDropdownValues = (updateObj) => {
    if (updateObj.type == "State") {
      setFilterInput({
        ...filterInput,
        stateId: updateObj.value || 0,
        stateName: updateObj.label || 0,
      });
    } else if (updateObj.type == "Grade") {
      setFilterInput({
        ...filterInput,
        gradeId: updateObj.value || 0,
        gradeName: updateObj.label || 0,
        contentAreaId: 0,
        contentAreaName: "",
        subjectId: 0,
        subjectName: "",
      });
      bindContentAreaByGrade(props.profile?.userId, updateObj.value, 0);
    } else if (updateObj.type == "Subject") {
      setFilterInput({
        ...filterInput,
        subjectId: updateObj.value || 0,
        subjectName: updateObj.label || 0,
      });
    } else if (updateObj.type == "GradeLevel") {
      setFilterInput({
        ...filterInput,
        gradeLevelId: updateObj.value || "",
        gradeLevelName: updateObj.label || "",
      });
    } else if (updateObj.type == "ContentArea") {
      setFilterInput({
        ...filterInput,
        contentAreaId: updateObj.value || 0,
        contentAreaName: updateObj.label || "",
        subjectId: 0,
        subjectName: "",
      });

      bindSubjectByContent(
        props.profile?.userId,
        filterInput.gradeId,
        updateObj.value
      );
    } else if (updateObj.type == "subjectType") {
      setFilterInput({
        ...filterInput,
        subjectTypeId: updateObj.value || 0,
        subjectTypeName: updateObj.label || 0,
      });
    }
  };

  const previewFileHandler = (path: any) => {
    previewSuperSheet(path).then((response) => {
      const fileURL = response.data;
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    });
  };

  const downloadAnswerKeyFile = (supersheetId: any) => {
    downloadaAnswerKeySupersheet(supersheetId, props.profile?.userId).then(
      (response) => {
        const file = response.data;
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      }
    );
  };

  function handleShareSupersheetConfimation(confirmAction: boolean) {
    setShowConfirmation(false);
    resetClickHandler();
  }
  function handleShareSupersheet(
    supersheetId: number,
    title: string,
    subjectId: number,
    subjectName: string,
    shareSubjectIds: string
  ) {
    setSelectedSupersheetId(supersheetId);
    setSelectedTitle(title);
    setSelectedSubjectId(subjectId);
    setSelectedSubjectName(subjectName);
    setSelectedShareSubjectIds(shareSubjectIds);
    setShowConfirmation(true);
  }

  //Methods
  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setSortCol(column);
  };
  function redirectToSupersheetDetail(supersheetId: number) {
    if (supersheetId) {
      navigate(constant.EDITSUPERSHEET.replace(":id", supersheetId.toString()));
    } else {
      navigate(constant.ADDSUPERSHEET);
    }
  }

  useEffect(() => {
    if (isLoaded) {
      filterSupersheets();
    }
  }, [sortByDesc]);

  useEffect(() => {
    if (isLoaded && !isFilter) {
      getSupersheetData();
      getGradeData();
      getSubjectData();
      getContent();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      getSupersheetData();
      getGradeData();
      getSubjectData();
      getContent();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const exportFn = async () => {
    setLoading(true);
    const supersheetData: ISupersheetFilter = {
      name: filterInput.name || "",
      subjectId: filterInput.subjectId || 0,
      contentAreaId: filterInput.contentAreaId || 0,
      gradeId: filterInput.gradeId || 0,
      gradeLevel: filterInput.gradeLevelId || "",
      orderbyColumn: sortCol,
      sortDir: sortByDesc ? "desc" : "asc",
      pageSize: 9999,
      pageNumber: 1,
      isActive: filterInput.isActive,
      isApproved: filterInput.isApproved,
      supersheetId: filterInput.supersheetId || 0,
      subjectTypeId: filterInput.subjectTypeId,
    };

    const response = getSupersheet(supersheetData);
    const data = (await response).data;
    setLoading(false);
    if (data && data.data && data.data.length > 0) {
      const superSheetExportData = data.data.map((s) => {
        return {
          SuperSheetId: s.superSheetId,
          Title: s.title,
          GradeId: s.gradeId,
          GradeName: s.gradeName,
          SubjectId: s.subjectId,
          SubjectName: s.subjectName,
          ContentAreaId: s.contentAreaId,
          ContentAreaName: s.contentAreaName,
          NumberOfQuestions: s.numberOfQuestions,
          AnswerKeyPdfName: s.answerKeyPdfName,
          AnswerKeyPath: s.answerKeyPath,
          SpanishPdfName: s.spanishPdfName,
          SpanishPdfPath: s.spanishPdfPath,
          EnglishPdfName: s.englishPdfName,
          EnglishPdfPath: s.englishPdfPath,
          AnswerKeyCount: s.answerKeyCount,
        };
      });
      childRef?.current?.onDownload(superSheetExportData, "supersheet.csv");
    } else {
      toast.warning("No records to download");
    }
  };

  return (
    <AllowedTo
      perform={Permissions.supersheet_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showConfirmation && (
        <ShareSupersheet
          supersheetId={selectedSupersheetId}
          subjectName={selectedSubjectName}
          shareSubjectIds={selectedShareSubjectIds}
          contentAreas={newContent}
          title={"Share Supersheet"}
          confirmAction={handleShareSupersheetConfimation}
          message={"Please Select Supersheet"}
          buttonText={"Share"}
          userId={props.profile?.userId}
        />
      )}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">Supersheets</h3>
              <AllowedTo perform={Permissions.supersheet_create}>
                <button
                  onClick={(e) => {
                    redirectToSupersheetDetail(0);
                  }}
                  type="button"
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transition ease-in-out duration-300"
                >
                  <AddIcon className="w-5"></AddIcon>
                  Add SuperSheet
                </button>
              </AllowedTo>
            </div>

            <form action="#" onSubmit={filterHandler}>
              <div className="pt-6 border-b pb-6">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">
                      Supersheet Id
                    </label>
                    <input
                      id="supersheetId"
                      name="supersheetId"
                      type="number"
                      autoComplete="off"
                      className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      value={filterInput.supersheetId}
                      onChange={filterInputChangeHandler}
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Grade</label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.gradeName,
                        value: filterInput.gradeId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "Grade" })
                      }
                      options={newGrade}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">
                      Content Area
                    </label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.contentAreaName,
                        value: filterInput.contentAreaId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "ContentArea" })
                      }
                      options={newContent}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Subject</label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.subjectName,
                        value: filterInput.subjectId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "Subject" })
                      }
                      options={newSubject}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <button
                    type="submit"
                    className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>

                  <button
                    type="button"
                    onClick={resetClickHandler}
                    className="py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>
              <div className="flex mt-4 justify-end">
                <div className="flex space-x-4 items-center dark:text-white">
                  <button
                    type="button"
                    onClick={() => exportFn()}
                    className="py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                    <span>Export</span>
                  </button>

                  <ExportToCSV ref={childRef} />
                </div>
              </div>
            </form>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 relative  sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Id
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "supersheetId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("supersheetId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("supersheetId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Title
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "title" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("title")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("title")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Grade
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "grade" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("grade")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("grade")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Content Area
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "contentArea" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("contentArea")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("contentArea")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Subject
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "subject" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("subject")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("subject")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Number Of Questions
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  sortCol === "numberOfQuestions" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("numberOfQuestions")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("numberOfQuestions")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Answer Key</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Spanish Pdf</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">English Pdf</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            ></th>
                          </tr>
                        </thead>

                        <tbody>
                          {newSupersheet.map((supersheet, index) => (
                            <tr
                              key={index}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-100"
                              }
                            >
                              <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                <div className="flex ml-2">
                                  <Link
                                    className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                    to={constant.EDITSUPERSHEET.replace(
                                      ":id",
                                      supersheet.superSheetId.toString()
                                    )}
                                  >
                                    {supersheet.superSheetId}
                                  </Link>
                                </div>
                              </td>

                              <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                <div className="flex items-center">
                                  <Link
                                    className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                    to={constant.EDITSUPERSHEET.replace(
                                      ":id",
                                      supersheet.superSheetId.toString()
                                    )}
                                  >
                                    {supersheet.title}
                                  </Link>
                                </div>
                              </td>

                              <td className="px-3 py-2 capitalize text-sm font-normal text-gray-500">
                                <Link
                                  className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                  to={constant.EDITGRADE.replace(
                                    ":id",
                                    supersheet.gradeId.toString()
                                  )}
                                >
                                  {supersheet.gradeName}
                                </Link>
                              </td>

                              <td className="px-3 py-2 capitalize text-sm font-normal text-gray-500">
                                <Link
                                  className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                  to={constant.EDITCONTENT.replace(
                                    ":id",
                                    supersheet.contentAreaId?.toString()
                                  )}
                                >
                                  {supersheet.contentAreaName}
                                </Link>
                              </td>

                              <td className="px-3 py-2 w-68 text-sm font-normal text-gray-500">
                                {supersheet.subjectName}
                              </td>
                              <td className="px-3 py-2 text-center whitespace-nowrap text-sm font-normal text-gray-500">
                                {supersheet.answerKeyCount > 0
                                  ? supersheet.answerKeyCount
                                  : ""}
                              </td>

                              <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                {supersheet.answerKeyCount > 0 && (
                                  <WorksheetIcon
                                    title={supersheet.answerKeyPdfName}
                                    className="w-4 text-red-600 cursor-pointer m-auto"
                                    onClick={() => {
                                      downloadAnswerKeyFile(
                                        supersheet.superSheetId
                                      );
                                    }}
                                  />
                                )}
                              </td>

                              <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                {supersheet.spanishPdfName && (
                                  <WorksheetIcon
                                    title={supersheet.spanishPdfName}
                                    className="w-4 text-red-600 cursor-pointer m-auto"
                                    onClick={() => {
                                      previewFileHandler(
                                        supersheet.spanishPdfPath
                                      );
                                    }}
                                  />
                                )}
                              </td>

                              <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                {supersheet.englishPdfName && (
                                  <WorksheetIcon
                                    title={supersheet.englishPdfName}
                                    className="w-4 text-red-600 cursor-pointer m-auto"
                                    onClick={() => {
                                      previewFileHandler(
                                        supersheet.englishPdfPath
                                      );
                                    }}
                                  />
                                )}
                              </td>

                              <td className="flex justify-end items-center px-3 py-2 text-sm text-center font-normal text-gray-700">
                                <div className="flex justify-center items-center space-x-2">
                                  <Menu
                                    as="div"
                                    className="relative flex justify-end items-center"
                                  >
                                    <Menu.Button className="h-7 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bg-primary-color">
                                      <span className="sr-only">
                                        Open options
                                      </span>
                                      <DotsVerticalIcon
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>

                                    <Transition
                                      as={Fragment}
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <Menu.Items className="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
                                        <div className="py-1">
                                          <Menu.Item>
                                            {({ active }) => (
                                              <a
                                                onClick={(e) => {
                                                  handleShareSupersheet(
                                                    supersheet.superSheetId,
                                                    supersheet.title,
                                                    supersheet.subjectId,
                                                    supersheet.subjectName,
                                                    supersheet.shareSubjectIds
                                                  );
                                                }}
                                                className={classNames(
                                                  active
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-700",
                                                  "group flex items-center px-4 py-2 text-sm"
                                                )}
                                              >
                                                <CopyIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                                                Share
                                              </a>
                                            )}
                                          </Menu.Item>
                                          <Menu.Item>
                                            {({ active }) => (
                                              <a
                                                onClick={() =>
                                                  handleRedirect(
                                                    supersheet.superSheetId
                                                  )
                                                }
                                                className={classNames(
                                                  active
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-700",
                                                  "group flex items-center px-4 py-2 text-sm"
                                                )}
                                              >
                                                <EditIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                                                Edit
                                              </a>
                                            )}
                                          </Menu.Item>
                                        </div>
                                      </Menu.Items>
                                    </Transition>
                                  </Menu>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  className={`flex justify-between items-center ${
                    newSupersheet.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />

                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                    />
                  </span>
                </div>

                {newSupersheet.length === 0 && (
                  <p className="p-2">No Records Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(Supersheet);
